import script from "./product-list.vue?vue&type=script&setup=true&lang=js"
export * from "./product-list.vue?vue&type=script&setup=true&lang=js"

import "./product-list.vue?vue&type=style&index=0&id=6ba3209a&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ba3209a"]])

export default __exports__